import I18n from 'I18n';
import unescapedText from 'I18n/utils/unescapedText';
import { getCallSourceLabel } from './getCallSourceLabel';
// date numbers and month names follow the explicit `locale` arg via moment
//
// connector words ("at", "via", "with") come from I18n.text against the
// global I18n singleton's locale, not the explicit `locale` arg
//
// when the public viewer sets the singleton to the recipient's chosen
// locale at boot, connectors and dates render together
//
// when the singleton stays in the sender's locale (like inside the lib's
// preview modal), dates flip with the dropdown but connectors stay in
// the sender's locale, which is fine for a preview
export const formatMeetingDateTime = ({
  startTime,
  endTime,
  callSource,
  notetakerLabel,
  locale
}) => {
  const start = I18n.moment(startTime).locale(locale);
  const date = start.format('ll');
  const startTimeStr = start.format('LT');
  const timezone = I18n.moment.userTz().locale(locale).format('z');
  const dateTimeRange = endTime === null ? unescapedText('external-sharing-components.meetingDetails.dateAtSingleTime', {
    date,
    startTime: startTimeStr,
    timezone
  }) : unescapedText('external-sharing-components.meetingDetails.dateAtTimeRange', {
    date,
    startTime: startTimeStr,
    endTime: I18n.moment(endTime).locale(locale).format('LT'),
    timezone
  });
  const platform = getCallSourceLabel(callSource);
  if (!platform) return dateTimeRange;
  if (notetakerLabel) {
    return unescapedText('external-sharing-components.meetingDetails.viaPlatformWithNotetaker', {
      dateTimeRange,
      platform,
      notetakerLabel
    });
  }
  return unescapedText('external-sharing-components.meetingDetails.viaPlatform', {
    dateTimeRange,
    platform
  });
};